import React from "react";
import SvgIcon, { SvgIconProps } from "@mui/material/SvgIcon";
import { ReactComponent as Icon } from "../svg/Pepsico.svg";

export default function PepsiCoLogoIcon(props: SvgIconProps) {
  return <SvgIcon {...props} component={Icon} inheritViewBox fontSize="inherit" />;
}
